// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { ancient8 as _ancient8 } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the ancient8 chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 888888888
 * Chain Name: Ancient8
 * Default Block Explorer: https://scan.ancient8.gg
 * Default RPC URL: https://rpc.ancient8.gg
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { ancient8 } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: ancient8,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const ancient8 = createCommon({
	..._ancient8,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
